import { atom } from 'recoil';

export const isDirtyAtom = atom({
  key: 'isCustomerQueryBuilderDirty',
  default: false,
});
